import { EmailEntityId } from "@sp-crm/core";
import { QueryRenderer } from "components/clients/show-client/community-comparison/query-renderer";
import React from "react";
import { useFeature, useRegionId } from "store/selectors/hooks";
import {
    AdvancedSearchEntityType,
    useGetConversationFeedForEntityQuery,
} from "../../generated/graphql";
import { Spinner } from "../ui/spinner";
import { ConversationFeed } from "./conversation-feed";
import { ConversationFeedLegacy } from "./conversation-feed-legacy";

interface EntityConversationFeedProps {
    entityId: EmailEntityId;
    initialThreadId?: string;
    entityType?: AdvancedSearchEntityType;
}

export const EntityConversationFeed: React.FC<EntityConversationFeedProps> = props => {
    const { entityId, initialThreadId, entityType } = props;
    const regionId = useRegionId();
    const inboxVNextEnabled = useFeature("inboxVNext");

    const conversationQuery = useGetConversationFeedForEntityQuery(
        { entityId, regionId: regionId! },
        { enabled: !!regionId },
    );

    return (
        <QueryRenderer query={conversationQuery} name="EntityConversationFeed">
            {data => {
                if (!data.getConversationFeedForEntity) {
                    return <Spinner />;
                }

                if (inboxVNextEnabled) {
                    return (
                        <ConversationFeed
                            feed={data.getConversationFeedForEntity}
                            initialThreadId={initialThreadId}
                            entityId={entityId}
                            entityType={entityType}
                        />
                    );
                }

                return (
                    <ConversationFeedLegacy
                        feed={data.getConversationFeedForEntity}
                        initialThreadId={initialThreadId}
                        entityId={entityId}
                        entityType={entityType}
                    />
                );
            }}
        </QueryRenderer>
    );
};
